import { capitalize } from 'lodash'

/**
 * @typedef {import('../index').AnySlateNode} AnySlateNode
 */

/**
 * @param {String} s
 * @return {String}
 */
export const screamingSnakeCaseToHumanReadable = (s) => {
  return s
    .split('_')
    .map((sub) => {
      return capitalize(sub.toLowerCase())
    })
    .join(' ')
}

/**
 * Produce true if the given slate children or single arbitrary slate
 * node corresponds with empty content.  (In that sub-tree of slate
 * content anyway.)
 *
 * @param {Array<AnySlateNode> | AnySlateNode} children
 * @return {boolean}
 */
export const isEmpty = (children) => {
  if (!children) return true

  /**
   * @param {AnySlateNode | Array<AnySlateNode>} node
   * @return {boolean}
   */
  function anyText(node) {
    if (Array.isArray(node)) {
      return node.some(anyText)
    } else if (!node) {
      return false
    } else if (node && typeof node === 'object') {
      return Object.entries(node).some(([key, value]) => {
        return (key === 'text' && typeof value === 'string' && value !== '') || anyText(value)
      })
    } else {
      return false
    }
  }

  return !anyText(children)
}
